import React from 'react';
import { ButtonWrapper, IconsTabWrapper, TabButton, TabLineButton, TabText, TabsWrapper } from '../../styles/button.style';
import { useTankCleaningStore } from '../../context/TankCleaningContext';
import { ReportingContextInfo, StatusInfoWrapper, TabsPanelHeader } from '../../styles/panel.style';
import queryParamsUtils from '../../utils/queryParamsUtils';
import OrderStatus from './chemical-order/OrderStatus';
import { ChemicalOrderStatusEnum } from '../../enums/chemicalOrderStatusEnum';
import ProcessButtonManagerForOrderComponent from './chemical-order/ProcessButtonManagerForOrder';
import { PortCall } from '../../types/ViewModel/PortCall';
import OrderStatusIconList from './chemical-order/OrderStatusIconList';
import UpdateOrderStatus from './chemical-order/UpdateOrderStatus';
import { isDateBefore } from 'odfjell-date-time-utils/dateTimeUtils';
import { getRobIcon } from '../ui/status-icon/CargoConsumablesIcon';

type Props = {
    selectedTankCleaningPortCall: PortCall;
};

const ConsumablesHeader: React.FC<Props> = (props) => {
    const {
        isOrderPanelVisible,
        selectedChemicalOrderForPortCall,
        chemicalOrderUpdateReportData,
        chemicalRobUpdateReportData,
        chemicalReportType,
        isSummaryActive,
        setIsSummaryActive,
    } = useTankCleaningStore();
    const { setQueryParamChemicalReportType } = queryParamsUtils();

    const onClickChangePanel = (reportType: string) => {
        if (reportType !== chemicalReportType) {
            setQueryParamChemicalReportType(reportType);
        }
    };

    const onPrintRob = () => {
        window.print();
    };

    const getUpdateOrderStatus = (portCallItem: PortCall): number => {
        return portCallItem.chemicalOrderForPortCallList
            .sort((a, b) => (isDateBefore(a.createdUtc, b.createdUtc) ? 1 : -1))
            .filter((c) => c.parentOrderId === 0)[0]?.updateOrderStatusId;
    };

    return (
        <TabsPanelHeader columns={'0.5fr 0.75fr 1fr 1fr'}>
            <TabsWrapper tabs={'125px 125px'}>
                <TabButton className="first" isSelected={!isOrderPanelVisible} onClick={() => onClickChangePanel('rob')}>
                    <TabText>Rob reporting</TabText>
                    <IconsTabWrapper>{getRobIcon(props.selectedTankCleaningPortCall)}</IconsTabWrapper>
                </TabButton>
                <TabButton className="last" isSelected={isOrderPanelVisible} onClick={() => onClickChangePanel('order')}>
                    <TabText>Order form</TabText>
                    <IconsTabWrapper>
                        {props.selectedTankCleaningPortCall.chemicalOrderForPortCallList.length > 0 &&
                            props.selectedTankCleaningPortCall.chemicalOrderForPortCallList[0]?.lastOrderStatusId && (
                                <>
                                    <OrderStatusIconList
                                        chemicalOrderForPortCallList={props.selectedTankCleaningPortCall.chemicalOrderForPortCallList}
                                        iconsRightPos={0}
                                    />
                                    <UpdateOrderStatus
                                        updateOrderStatus={getUpdateOrderStatus(props.selectedTankCleaningPortCall)}
                                        showIcon={true}
                                        inList={false}
                                        inTab={true}
                                    />
                                </>
                            )}
                    </IconsTabWrapper>
                </TabButton>
            </TabsWrapper>
            <ReportingContextInfo>
                {!isOrderPanelVisible && (
                    <span className="reporting-context-info">
                        Reporting at
                        <span className="port-call-name">{props.selectedTankCleaningPortCall.port.portName}</span>
                    </span>
                )}
                {isOrderPanelVisible && (
                    <span className="reporting-context-info">
                        Ordering to
                        <span className="port-call-name">{props.selectedTankCleaningPortCall.port.portName}</span>
                    </span>
                )}
            </ReportingContextInfo>
            <StatusInfoWrapper>
                {isOrderPanelVisible && (
                    <OrderStatus
                        chemicalOrderStatus={
                            selectedChemicalOrderForPortCall ? selectedChemicalOrderForPortCall.lastOrderStatusId : ChemicalOrderStatusEnum.Unsaved
                        }
                        type={'text'}
                    ></OrderStatus>
                )}
            </StatusInfoWrapper>

            {isOrderPanelVisible && chemicalOrderUpdateReportData && <ProcessButtonManagerForOrderComponent></ProcessButtonManagerForOrderComponent>}
            {!isOrderPanelVisible && chemicalRobUpdateReportData && (
                <ButtonWrapper>
                    <TabLineButton type="button" className="" disabled={!isSummaryActive} onClick={() => onPrintRob()}>
                        Print ROB
                    </TabLineButton>
                    <TabLineButton isSelected={isSummaryActive} onClick={() => setIsSummaryActive(!isSummaryActive)}>
                        Summary
                    </TabLineButton>
                </ButtonWrapper>
            )}
        </TabsPanelHeader>
    );
};

export default ConsumablesHeader;
